class DiscountNotice extends HTMLElement {
  constructor() {
    super();

    this.cookieName = 'discount_code';
    this.para = this.querySelector('p');

    document.addEventListener('theme:discountApplied', this.determineModal.bind(this));
    this.determineModal();
  }

  showModal() {
    this.setAttribute('aria-hidden', 'false');
  }

  hideModal() {
    this.setAttribute('aria-hidden', 'true');
  }

  setMessage() {
    this.para.innerHTML = `${this.dataset.pretext}${this.getCookie(this.cookieName)}${this.dataset.posttext}`;
  }

  determineModal() {

    if (!this.hasCookie(this.cookieName)) return;

    this.setMessage();
    this.showModal();
  }

  /*
  * Helper to get a cookie.
  *
  * @param cname: Name of the cookie.
  */
  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  /*
  * Helper to check if a cookie exists.
  *
  * @param cname: Name of the cookie.
  */
  hasCookie(cname) {
    let cookie = this.getCookie(cname);
    if (cookie != "") {
      return true;
    } else {
      return false;
    }
  }
}

customElements.define('discount-notice', DiscountNotice);